export default function (/**@type {ApisauceInstance} */ api) {
  const getAllVisits = (paging) => api.get(`Visits/get-all-visits`, paging);

  const getVisitWithId = (id) => api.get(`Visits/get-visit-by-id/${id}`);

  return {
    visits: {
      getAllVisits,
      getVisitWithId,
    },
  };
}
